module.exports = __webpack_public_path__ + "img/4.47574ac9.png";